import React, { useState, useEffect, useRef, Fragment } from 'react'
import { Link, withRouter, useHistory } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import Notification from '../../Utils/Notification'
import Modal from 'react-modal'
import MediaQuery from 'react-responsive'
import Chip from '@mui/material/Chip'
import '../../css/chat.css'
import { ChatMessage } from '../../Utils/ChatMessage'
import { NotificationByPlaceBadge } from '../Notification/NotificationBadge'
import { useNotification } from '../Notification/NotificationContext'

Modal.setAppElement('#root')

const useQueryParam = (param) => {
  const url = window.location.search
  const params = new URLSearchParams(url)
  return params.get(param) || ''
}

const ListBookings = () => {
  const [requests, setRequests] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [reason, setReason] = useState('')
  const [bookingReference, setBookingReference] = useState({})

  const id = useQueryParam('id')

  const [highlightedBookingId, setHighlightedBookingId] = useState(id)

  const requestsRef = useRef([])

  useEffect(() => {
    getRequests()
  }, [])

  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '90%', // 90% of the screen width
      maxWidth: '600px', // Max width for larger screens
      padding: '20px', // Optional: add some padding for content
      boxSizing: 'border-box', // Ensure padding doesn't overflow the modal
      borderRadius: '8px', // Optional: Rounded corners for a nicer look
      overflow: 'hidden',
    },
  }

  const openModal = () => {
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setModalIsOpen(false)
  }

  const acceptRequest = (id) => {
    const formData = { reason }
    axios
      .post(`/api/bookings/accept/${id}`, formData)
      .then(() => {
        Notification({
          type: 'success',
          message: 'This request has been accepted.',
        })
        getRequests()
        setHighlightedBookingId(null)
      })
      .catch(function (error) {
        Notification({
          type: 'error',
          message: 'This request could not be accepted.',
        })
        console.log('Request failure: ', error)
      })
  }

  const declineRequest = (id) => {
    const formData = { reason }
    axios
      .post(`/api/bookings/decline/${id}`, formData)
      .then(() => {
        Notification({
          type: 'success',
          message: 'This request has been declined.',
        })
        getRequests()
        setHighlightedBookingId(null)
      })
      .catch(function (error) {
        Notification({
          type: 'error',
          message: 'This request could not be declined.',
        })
        console.log('Request failure: ', error)
      })
  }

  const getRequests = (highlightedBookingId = null) => {
    axios
      .get('/api/bookings')
      .then((response) => {
        let results = []
        const sortedBookings = [...response.data].sort((a, b) => {
            return new Date(b.request_sent_at).getTime() - new Date(a.request_sent_at).getTime();
          });

        sortedBookings.forEach((request, index) => {
          let status =
            request.status.toLowerCase() === 'pending-verification'
              ? 'PENDING'
              : request.status.toUpperCase()
          results.push(
            <BookingRequest
              key={request.id}
              id={request.id}
              guests={request.guests}
              guest={request.guest}
              place={request.place}
              message={request.message}
              highlightedBookingId={highlightedBookingId}
              currency={request.currency}
              propertyPrice={request.property_price}
              status={status}
              startDate={request.start_date}
              endDate={request.end_date}
              hostReason={request.hostReason}
              acceptRequest={acceptRequest}
              declineRequest={declineRequest}
              index={index}
              openModal={openModal}
              closeModal={closeModal}
              setReason={setReason}
              setBookingReference={setBookingReference}
              requestsRef={requestsRef}
              setHighlightedBookingId={setHighlightedBookingId}
              messages={request.messages}
              unReadMessages={request.unReadMessages.length}
            />
          )
        })
        setRequests(results)
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
  }

  useEffect(() => {
    if (highlightedBookingId === null && window.location.search) {
      const currentPath = window.location.pathname
      const urlParams = new URLSearchParams(window.location.search)

      urlParams.delete('id')
      const newUrl = `${currentPath}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`
      window.history.replaceState(null, '', newUrl)
    }
  }, [highlightedBookingId])

  useEffect(() => {
    if (highlightedBookingId) {
      getRequests(highlightedBookingId)
    }
  }, [highlightedBookingId])

  if (requests.length === 0) {
    return (
      <section id="bookingRequests">
        <div className="text-center">
          <p>
            If you are a Freebird Homestays host the Homestay requests received
            for your property will appear here.
          </p>
          <p>
            You can view the request details, the member details, and accept or
            reject the request.
          </p>
        </div>
      </section>
    )
  } else {
    return (
      <Fragment>
        <section id="bookingRequests" className="main-wrapper">
          <div className="container">
            <ul className="responsive-table">
              <li className="table-header">
                <div className="col-field-1">User</div>
                <div className="col-field-2">Nº Guests</div>
                <div className="col-field-3">Arrival date</div>
                <div className="col-field-4">Departure date</div>
                <div className="col-field-5">Status</div>
                <div className="col-icon" />
              </li>
              {requests}
            </ul>
          </div>
        </section>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={{ content: { ...modalStyles.content } }}
          contentLabel="Status Reason Modal"
          bodyOpenClassName="listBooking-modal"
        >
          <div className="listBooking__modal-wrapper">
            <h3>Message to guest:</h3>
            <textarea
              rows="4"
              onChange={(e) => {
                setReason(e.target.value)
              }}
              value={reason}
            />
            <div className="listbooking__modal-wrapper__button-wrapper">
              <div
                className="btn btn-gray font-open-sans font-size-14 font-weight-700 text-white"
                onClick={closeModal}
              >
                Cancel
              </div>
              <div
                className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                onClick={() => {
                  bookingReference.type == 'accept'
                    ? acceptRequest(bookingReference.id)
                    : declineRequest(bookingReference.id)
                  closeModal()
                  requestsRef.current[bookingReference.index].style.height = ''
                }}
              >
                Send
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}

const BookingRequest = ({
  id,
  highlightedBookingId,
  guests,
  message,
  currency,
  propertyPrice,
  hostReason,
  status,
  startDate,
  endDate,
  guest,
  place,
  index,
  openModal,
  setReason,
  setBookingReference,
  requestsRef,
  setHighlightedBookingId,
  messages,
  unReadMessages,
}) => {
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (String(id) === String(highlightedBookingId)) {
      expandRow(index)
    }
  }, [highlightedBookingId, id])

  const history = useHistory()
  const { fetchUnreadCount } = useNotification()

  const handleGoToMessage = async () => {
    const from = window.location.pathname
    // update here

    try {
      const response = await axios.post(`/api/messages/mark-message-as-read`, {
        id,
      })
      console.log('Message update response:', response.data)
    } catch (error) {
      console.error('Error updating unread messages:', error.message || error)
    }
    fetchUnreadCount() // refresh the unread in the context file
    history.push(`/send-message/${id}`, { from }) // send to message box
  }

  useEffect(() => {
    const handleRemoveHighlight = (event) => {
      const clickedElement = event.target

      const isInsideRow = requestsRef.current.some(
        (element) => element && element.contains(clickedElement)
      )

      if (isInsideRow && highlightedBookingId !== null) {
        setHighlightedBookingId(null)
      }
    }

    document.addEventListener('click', handleRemoveHighlight)

    return () => {
      document.removeEventListener('click', handleRemoveHighlight)
    }
  }, [highlightedBookingId, requestsRef])

  const expandRow = (index) => {
    const element = requestsRef.current[index]
    if (!element) return

    const shouldExpand = !expanded

    if (shouldExpand) {
      // Expanding
      element.classList.add('expanded')
      element.style.backgroundColor = '#ffd966'
      element.style.border = '1px solid #c49a00'
      setTimeout(() => {
        const height = element.scrollHeight
        element.style.height = `${height}px`
      }, 0)
    } else {
      // Collapsing
      element.classList.remove('expanded')
      element.style.backgroundColor = 'transparent'
      element.style.border = 'none'
      element.style.height = '76px'
    }

    setExpanded(shouldExpand)
    if (highlightedBookingId) {
      setHighlightedBookingId(null)
    }
  }

  return (
    <>
      <div
        className={`table-row-container${expanded ? ' expanded' : ''}`}
        ref={(el) => (requestsRef.current[index] = el)}
        style={{
          transition:
            'height 0.3s ease, background-color 0.3s ease, border 0.3s ease',
          height: '76px',
          overflow: 'hidden',
          borderRadius: '8px',
        }}
      >
        <li className="table-row" onClick={() => expandRow(index)}>
          <div className="col-field-1" data-label="User">
            {guest.niceName}
          </div>
          <div className="col-field-2" data-label="Nº Guests">
            {guests}
          </div>
          <div className="col-field-3" data-label="Check-in">
            {startDate}
          </div>
          <div className="col-field-4" data-label="Check-out">
            {endDate}
          </div>
          <div
            className={`col-field-5 tag-${status.toLowerCase()}`}
            data-label="Status"
          >
            <Chip label={status} />
          </div>
          <div className={`col-icon${expanded ? ' expanded' : ''}`}>
            <div className="arrow-icon" />
          </div>
          <NotificationByPlaceBadge count={unReadMessages} />
        </li>
        <div className="col-12 mb-4">
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <div className="row property-details">
                <div className="col-5 col-md-12 text-right text-md-left details-text">
                  <div className="row">
                    <div className="font-all-round font-weight-300 font-size-20 text-black w-100 mb-2">
                      Property Details:
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-5 d-flex justify-content-end justify-content-md-start  justify-content-xs-start">
                      <div className="row">
                        <div className="place-image">
                          <img
                            src={s3AwsEndpoint + '/' + place.photo}
                            onError={(e) => {
                              e.target.onError = null
                              e.target.src =
                                '/images/listing/profile-coming-soon.png'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-7">
                      <div className="row ml-0">
                        <span className="font-all-round font-weight-600 font-size-20 text-black w-100">
                          {place.name}
                        </span>
                        <span className="font-open-sans font-weight-600 font-size-14 w-100">
                          <img src="/images/icons/location.svg" alt="" />{' '}
                          {place.location}
                        </span>
                        <span
                          className="font-open-sans font-weight-600 font-size-14 w-100"
                          dangerouslySetInnerHTML={{
                            __html: `<img src="/images/icons/tag.svg" alt=""/> ${currency}${propertyPrice} - per night`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row guest-details">
                <div className="col-5 col-md-12 text-right text-md-left details-text">
                  <div className="row">
                    <div className="font-all-round font-weight-300 font-size-20 text-black w-100 mb-2">
                      Guest Details:
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-5 d-flex justify-content-end justify-content-md-start justify-content-xs-start">
                      <div className="row">
                        <div className="guest-image">
                          <img
                            src={s3AwsEndpoint + '/' + guest.photo}
                            onError={(e) => {
                              e.target.onError = null
                              e.target.src =
                                '/images/listing/profile-coming-soon.png'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-7">
                      <div className="row ml-0">
                        <h5 className="m-0 w-100">
                          <Link
                            to={`/user/${guest.id}`}
                            className="font-size-20"
                          >
                            {guest.name}
                          </Link>
                        </h5>
                        <span className="font-open-sans font-weight-600 font-size-14 w-100">
                          <img src="/images/icons/location.svg" alt="" />{' '}
                          {guest.location}
                        </span>

                        {/*
                        {status.toLowerCase() !== null && (
                          <>

                            <div style={{
                              margin: '10px 0',
                              padding: '10px 15px',
                              borderRadius: '5px',
                              backgroundColor: '#f0f0f0'
                            }}>
                              <p style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginBottom: '5px'
                              }}>Request Message from Guest:</p>
                              <p style={{
                                fontSize: '12px',
                                lineHeight: '1.5',
                              }}>{message}</p>
                            </div>
                          </>)} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <li className="table-row table-row__expanded-content">
          <div className="col-12 col-md-12 mb-3">
            {messages.length > 0 && (
              <div class="chat-preview-container">
                {messages.length >= 3 && (
                  <Link
                    className="continue-chat-link"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleGoToMessage()
                    }}
                    dangerouslySetInnerHTML={{
                      __html: `view older messages...`,
                    }}
                  />
                )}

                {messages.length > 0
                  ? messages
                      .slice()
                      .reverse()
                      .map((msg, index) => (
                        <ChatMessage
                          key={index}
                          classType={'chat-preview-message'}
                          className={msg.userId === guest.id ? 'guest' : 'host'}
                          message={msg.message}
                          timestamp={msg.sendDate}
                        />
                      ))
                  : ''}
              </div>
            )}
          </div>
          <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-stretch">
            <Link
              to="#"
              className="btn btn-outline-secondary   flex-grow-1  w-100 text-center mb-3 mb-md-0 ml-md-3 text-decoration-none"
              onClick={(e) => {
                e.preventDefault()
                handleGoToMessage()
              }}
            >
              Message Guest
            </Link>
            {status === 'PENDING' && (
              <>
                <button
                  className="btn btn-success  flex-grow-1  text-center mb-3 mb-md-0 ml-md-3"
                  onClick={() => {
                    setBookingReference({ index, id, type: 'accept' })
                    setReason(
                      "Thanks for your enquiry. I'm delighted to accept and am looking forward to hosting you."
                    )
                    openModal()
                    setExpanded(false)
                  }}
                >
                  Accept
                </button>
                <button
                  className="btn btn-danger  flex-grow-1  text-center ml-md-3"
                  onClick={() => {
                    setBookingReference({ index, id, type: 'decline' })
                    setReason(
                      'Sorry, the property is not available on the dates you requested.'
                    )
                    openModal()
                    setExpanded(false)
                  }}
                >
                  Decline
                </button>
              </>
            )}
          </div>
        </li>
      </div>
    </>
  )
}

export default withRouter(withAuth(ListBookings))
